import { jsx as _jsx } from "react/jsx-runtime";
import { Tag } from '@/components/admin/shared';
/** Tipos de mensagem do sistema, com as mesmas cores da tela antiga. */
export const MESSAGE_TYPES = [
    { value: 'info', label: 'Info (Azul)', short: 'Info', tone: 'info' },
    { value: 'warning', label: 'Warning (Amarelo)', short: 'Warning', tone: 'warning' },
    { value: 'danger', label: 'Danger (Vermelho)', short: 'Danger', tone: 'danger' },
    { value: 'success', label: 'Success (Verde)', short: 'Success', tone: 'success' },
];
export function MessageTypeTag({ type }) {
    const found = MESSAGE_TYPES.find((t) => t.value === type);
    const label = found ? found.short : type ? type.charAt(0).toUpperCase() + type.slice(1) : '—';
    return _jsx(Tag, { tone: found ? found.tone : 'neutral', children: label });
}
